import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, ListChecks, User, LogOut, PenTool } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

const NAV = [
  { to: "/diy", label: "My Letters", icon: FileText, end: true },
  { to: "/diy/items", label: "My Items", icon: ListChecks },
  { to: "/diy/info", label: "My Info", icon: User },
];

export default function DiyLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [brand, setBrand] = useState({ company_name: "D&Z Management" });

  useEffect(() => {
    api.get("/public/branding").then((r) => setBrand(r.data)).catch(() => {});
  }, []);

  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#F8FAF8]">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {brand.logo_url
              ? <img src={brand.logo_url} alt="logo" className="h-8 w-8 rounded object-contain" />
              : <PenTool className="h-6 w-6 text-[#0B2545]" />}
            <div>
              <span className="font-heading font-bold text-lg text-[#0B2545]" data-testid="diy-brand-name">{brand.company_name}</span>
              <span className="ml-2 text-[10px] font-mono uppercase tracking-[0.18em] bg-amber-100 text-amber-800 rounded px-1.5 py-0.5">DIY Letters</span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-slate-500 hidden sm:block">{user?.name}</span>
            <button onClick={doLogout} data-testid="diy-logout-btn"
              className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 transition-colors duration-150">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
        <nav className="max-w-4xl mx-auto px-4 flex gap-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`diy-nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors duration-150 ${
                  isActive ? "border-[#0B2545] text-[#0B2545]" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
    </div>
  );
}
